import { Component, OnInit } from '@angular/core';
import { ClientDetailInstance } from 'app/clients/client-detail/client-detail.instance';
import { ActivatedRoute, Params } from '@angular/router';
import { EditClientModalComponent } from '../edit-client-modal/edit-client-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../../core/modal.service';

@Component({
  selector: 'cw-client-detail',
  templateUrl: './client-detail.component.html',
  styleUrls: ['./client-detail.component.scss'],
  providers: [ClientDetailInstance]
})

export class ClientDetailComponent implements OnInit {

  constructor(private instance: ClientDetailInstance,
              private route: ActivatedRoute,
              private modal: ModalService) {
  }

  ngOnInit() {
    this.instance.$client.subscribe(client => {
      if (client) {
        //this.titleService.setTitle(this.instance.project.name);
      }
    });

    this.route.params
      .subscribe((params: Params) => {
        this.instance.init(+params['id']);
      });
  }

  showEditModal() {
    const modalRef = this.modal.open(EditClientModalComponent);
    modalRef.componentInstance.initEdit(this.client);
    modalRef.result.then(client => {
      this.instance.reload();
    }).catch(() => {});
  }

  get client() {
    return this.instance.client;
  }

}



// WEBPACK FOOTER //
// ./src/app/clients/client-detail/client-detail.component.ts